import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import * as R from 'ramda';
import { returnField } from '../../utils/formHelpers';
import CardWrapper from '../common/CardWrapper';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { LoadingModal } from '../../utils/modalHelpers';
import { createUser } from '../../store/actions/userActions';

import { withTranslation } from 'react-i18next';
import { Field } from '../Field/Field.js';
import { useTheme } from '@mui/material';

const CreateNewUser = ({
  createUser,
  user,
  userCreateInProgress,
  t
}) => {
  const [formValues, setFormValues] = useState({ email: '' })
  const [submitting, setSubmitting] = useState(false)
  const theme = useTheme();

  const submitForm = useCallback(async event => {
    event.preventDefault()
    setSubmitting(true)
    await createUser(formValues)
    setFormValues({ email: '' })
    setSubmitting(false)
  }, [formValues, createUser])

  const pristine = formValues.email === ''

  return (
    <CardWrapper>
      <LoadingModal
        modalTitle="Wait-action-user"
        modalDescription="Wait-action-user"
        openState={userCreateInProgress}
        modalHeadline={t('userManagement.waitCreate', {
          email: user ? user.email : ' ',
        })}
        modalSubHeadline=""
      />
      <form onSubmit={submitForm}>
        <div style={{ paddingLeft: theme.spacing(2) }}>
          <Grid
            container
            spacing={4}
            direction="row"
            alignContent="flex-start"
            alignItems="flex-start"
          >
            <Grid item sm={12} md={6}>
              <Field
                component={returnField('text')}
                fullWidth
                label={t('userManagement.email')}
                name="email"
                required
                setValue={setFormValues}
                type="email"
                value={formValues.email}
              />
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={submitting || pristine}
              >
                {t('common.save')}
              </Button>
            </Grid>
          </Grid>
        </div>
      </form>
    </CardWrapper>
  );
};
const mapStateToProps = state => ({
  userCreateInProgress: R.path(['user', 'userCreateInProgress'], state),
  user: R.path(['user', 'user'], state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  createUser: formContent =>
    dispatch(createUser(formContent, R.path(['t'], ownProps))),
});

export default withTranslation('translations')(
  connect(mapStateToProps, mapDispatchToProps)(CreateNewUser)
);
